import { Block } from 'baseui/block';
import { themedUseStyletron } from '../../../theme/customTheme'
import { IValveTwoPoint } from './types'

// icons
import { GiValve } from "react-icons/gi";

export function SmallPanel(props: IValveTwoPoint) {
    const [, theme] = themedUseStyletron();

    return (
        <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='5px'>
            <GiValve color={props.isOpen ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='25px' />
        </Block>
    );
}